import http from './httpApplet.js'

export const getPatientInfo = params => {
  return http.getApplet(`/api/pat/getPatientInfo`, params)
}
export const getImageCloudUrl = params => {
  return http.getApplet(`/api/pat/getImageCloudUrl`, params)
}
// 获取微信sdk配置
export const getWeixinConfig = params => {
  return http.postApplet(`/api/wechat/getWxConfig`, params)
}
// 向院内提交开单申请
export const apply2YunInHospital = params => {
  return http.postApplet('/api/billing/apply2YunInHospital', params)
}
// 获取门诊预存余额
export const getAccountBalanceByPatId = params => {
  return http.getApplet('/api/pat/getAccountBalanceByPatId', params, 'query')
}
// 新增收货地址
export const addAddressApi = params => {
  return http.postApplet('/api/billing/addAddress', params)
}
// 获取寄件地址列表
export const getAddressListApi = params => {
  return http.getApplet('/api/billing/getAddressList', params, 'query')
}
// 获取患者寄件列表
export const getPatAddressApi = params => {
  return http.getApplet('/api/billing/getAddressListByChatRoom', params, 'query')
}
// 获取兰工的视频房间id
export const getByOriginalId = params => {
  return http.getApplet('/api/ask/getByOriginalId', params, 'query')
}
// 获取兰工的视频房间id
export const getVideoRoomId = params => {
  return http.getApplet('/api/common/getVideoRoomId', params, 'query')
}
// 删除快捷回复
export const deleteReply = params => {
  return http.deleteApplet('/api/template/delete', params)
}
// 新增快捷回复
export const addReply = params => {
  return http.postApplet('/api/template/add', params)
}
// 编辑快捷回复
export const editReply = params => {
  return http.putApplet('/api/template/edit', params)
}
// 查询快捷回复
export const getReply = prams => {
  return http.getApplet('/api/template/getList', prams, 'query')
}
// 结束会话更改状态
export const overConsult = params => {
  return http.putApplet('/api/ask/overConsult', params)
}
// 获取问卷列表
export const getFormList4Chat = params => {
  return http.getApplet('/api/preAsk/getFormList4Chat', params, 'query')
}



// WEBPACK FOOTER //
// ./packages/api/appletApi.js